import { defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import { ActivityEntitiesResponseSchema } from '../shared/schemas/activityEntities.js';

export type {
  ActivityEntityItemType,
  ActivityEntitiesResponseType,
} from '../shared/schemas/activityEntities.js';

export const getActivityEntities = defaultClient.query({
  url: 'omni-trafficking/v1/external-data/activity-entities/',
  method: 'GET',
  responseSchema: ActivityEntitiesResponseSchema,
  processResponse(data) {
    return data?.data?.items;
  },
  querySchema: z.object({
    integrationId: z.string(),
  }),
  snakeCaseQueryParams: true,
});
